import styled from 'styled-components';

export const EditableWrapper = styled.div`
	margin-bottom: 120px;
`;
